<template>
  <div class="spinner__wrap" :class="{ active: isLoading }">
    <div class="spinner">
      <div class="spinner-dot spinner-dot1"></div>
      <div class="spinner-dot spinner-dot2"></div>
      <div class="spinner-dot spinner-dot3"></div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "LoadingSpinner",
  setup() {
    const store = useStore();
    const isLoading = computed(() => store.getters["loading/isLoading"]);

    return {
      isLoading,
    };
  },
};
</script>
